<template>


<div class="container">
	<div class="row">
		<div class="col-lg-8">
		<h1>Data analytics</h1>
		<small class="text-muted">
			
		</small>
<p class="lead">
“Measurement is the first step that leads to control and eventually to improvement. If you can’t measure something, you can’t understand it. If you can’t understand it, you can’t control it. If you can’t control it, you can’t improve it.”
</p>
<p>
― H. James Harrington 
</p>
<p>
	Statistics and data analytics are not new tools in any business, however with IoT technologies helping to gather the data and AI technologies helping to process it we are able to get answers to the questions that were never possible before.
</p>


<p>
With advancing technologies we see more and more companies introducing data science into their business processes. From project planning to process controls, from finding process bottleneck to maintenance forecasts - data science can be the best tool for the job.
</p>
<p>
However, data science is complex and has many different fields that are used to solve different problems:
</p>
<ul>
	<li>process intelligence</li>
	<li>data mining</li>
	<li>visual analytics</li>
	<li>statistics</li>
	<li>AI and other algorithms</li>
</ul>


		</div>
		<div class="col-lg-4">


			<div class="card my-5">
				<div class="card-body bg-primary text-white">
					<h5 class="card-title text-white">Smart technologies</h5>
					<p class="card-text">
						Enhance your products and services, improve your customer experience by introducing AI, Deep Learning, Genetic Algorithms in your projects.
					</p>
					<a href="#/artificial_intelligence" class="btn btn-outline-white">More info</a>
				</div>
			</div>

		</div>
	</div>
</div>


</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "technology",
				title: "Data analytics"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
